import { Logger, engineComponent } from "neo-common";
import { Song } from "./Song";
import { ComponentTypes } from "../ComponentTypes";
import { SoundManager } from "../Managers/SoundManager";
import { TweenLite } from "gsap";

@engineComponent(ComponentTypes.PlayList)
export class PlayList {
    static Songs: { [id: string]: Song } = {};

    static addToPlayList(song: Song): void {
        PlayList.Songs[song.id] = song;
    }

    create(node: Element): void {
        SoundManager.parseElements(node, node.nodeName);
    }

    static play(song: string, fadeIn: number = 0, reset: boolean = true): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(false, fadeIn, reset);
        }
    }

    static loop(song: string, fadeIn: number = 0, reset: boolean = false): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(true, fadeIn, reset);
        }
    }

    static stop(song: string, fadeOut: number = 0): void {
        if (PlayList.Songs[song] != null) {
            TweenLite.killTweensOf(PlayList.Songs[song]);
            PlayList.Songs[song].stop(fadeOut);
        }
    }

    static stopAll(fadeOut: number = 0): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                TweenLite.killTweensOf(PlayList.Songs[song]);
                PlayList.Songs[song].stop(fadeOut);
            }
        }
    }

    static stopAllInGroup(group: string, toggle: boolean = false): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                TweenLite.killTweensOf(PlayList.Songs[song]);
                PlayList.Songs[song].toggleGroup(group, toggle);
            }
        }
    }

    static setVolume(song: string, volume: number): void {
        if (PlayList.Songs[song] != null) {
            TweenLite.killTweensOf(PlayList.Songs[song]);
            PlayList.Songs[song].setVolume(volume);
        }
    }

    static restoreVolume(song: string): void {
        if (PlayList.Songs[song] != null) {
            TweenLite.killTweensOf(PlayList.Songs[song]);
            PlayList.Songs[song].restoreVolume();
        }
    }

    static tweenSongVolume(
        song: string,
        values: Array<number>,
        duration: number,
        delay: number = 0,
        ease: string = "linear",
    ): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].setVolume(values[0]);
            duration = duration * 0.0167;

            TweenLite.killTweensOf(PlayList.Songs[song]);
            let tween = TweenLite.fromTo(
                PlayList.Songs[song],
                duration,
                { volume: values[0] },
                { volume: values[1], ease: ease, delay: delay },
            );
            tween.eventCallback("onUpdate", <() => void>PlayList.onSongVolumeUpdate, [PlayList.Songs[song]]);
        }
    }

    private static onSongVolumeUpdate(song: Song): void {
        song.setVolume(song["volume"]);
    }

    static log(s: string): void {
        if (DEBUG) {
            const compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Sounds/PlayList.ts
 **/